import * as React from "react";

function SvgSendGrid(props, ref) {
  return (
    <svg
      id="SendGrid_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 185 173.7"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".SendGrid_svg__st2{fill:#1a82e2}"}</style>
      <path fill="#fff" d="M156.2 23.2H71.3v42.4H28.8v84.9h84.9V108h42.5z" />
      <path
        opacity={0.4}
        fill="#00b2e3"
        d="M28.8 65.6V108h42.5v42.5h42.4V65.6z"
      />
      <path className="SendGrid_svg__st2" d="M28.8 108h42.4v42.4H28.8z" />
      <path fill="#00b2e3" d="M113.7 65.6V23.2H71.3V108h84.9V65.6z" />
      <path className="SendGrid_svg__st2" d="M113.7 23.2h42.4v42.4h-42.4z" />
    </svg>
  );
}

export default React.forwardRef(SvgSendGrid);
